import { Crop } from 'react-image-crop';
import { createCustomAction } from 'typesafe-actions';

import { Size } from '../../typings/common';
import { CreativeImageData } from '../common/typings';

import { CreativeImageCropSizeData, CreativeImageCropSizesValue } from './typings';

export const openModal = createCustomAction(
    '@canvasCreativeImageCropModal/OPEN',
    type => (
        imageData: CreativeImageData,
        sizeData: CreativeImageCropSizeData,
        isEditMode?: boolean,
        cropValue?: CreativeImageCropSizesValue
    ) => ({
        type,
        imageData,
        sizeData,
        isEditMode,
        cropValue
    })
);

export const closeModal = createCustomAction('@canvasCreativeImageCropModal/CLOSE');

export const cropComplete = createCustomAction('@canvasCreativeImageCropModal/CROP_COMPLETE', type => (crop: Crop) => ({
    type,
    crop
}));

export const saveModal = createCustomAction(
    '@canvasCreativeImageCropModal/SAVE',
    type => (image: HTMLImageElement) => ({ type, image })
);

export const showError = createCustomAction('@canvasCreativeImageCropModal/SHOW_ERROR', type => (message?: string) => ({
    type,
    message
}));

export const setImageSize = createCustomAction(
    '@canvasCreativeImageCropModal/SET_IMAGE_SIZE',
    type => (naturalImageSize: Size) => ({
        type,
        naturalImageSize
    })
);

export const changeSize = createCustomAction(
    '@canvasCreativeImageCropModal/CHANGE_SIZE',
    type => (selectedSize: number) => ({
        type,
        selectedSize
    })
);

export type CloseModal = ReturnType<typeof closeModal>;
export type OpenModal = ReturnType<typeof openModal>;
export type CropComplete = ReturnType<typeof cropComplete>;
export type SaveModal = ReturnType<typeof saveModal>;
export type ShowError = ReturnType<typeof showError>;
export type SetImageSize = ReturnType<typeof setImageSize>;
export type ChangeSize = ReturnType<typeof changeSize>;

export type CreativeImageCropModalAction =
    | CloseModal
    | OpenModal
    | CropComplete
    | SetImageSize
    | ShowError
    | ChangeSize
    | SaveModal;
